import { render } from "./SensorAlarms.vue?vue&type=template&id=015a64a0&scoped=true&ts=true"
import script from "./SensorAlarms.vue?vue&type=script&lang=ts"
export * from "./SensorAlarms.vue?vue&type=script&lang=ts"

import "./SensorAlarms.vue?vue&type=style&index=0&id=015a64a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015a64a0"]])

export default __exports__